import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { FormControl, FormHelperText } from "@mui/material";
import "../../App.css";

const MDPhoneInput = ({
  name,
  value,
  onChange,
  error,
  helperText,
  disabled,
}) => {
  return (
    <FormControl fullWidth error={error}>
      <PhoneInput
        country={"ca"}
        value={value}
        onChange={(phone) => {
          const formattedPhone = `+${phone}`;
          onChange({ target: { name, value: formattedPhone } });
        }}
        specialLabel=""
        disabled={disabled}
        inputStyle={{
          width: "100%",
          height: "56px",
          borderRadius: "10px",
          borderColor: error ? "#d32f2f" : "#ccc",
          background: "transparent",
          fontSize: "14px",
          paddingLeft: "48px",
        }}
        className={error ? "custom_tel_phone" : ""}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default MDPhoneInput;
